<div class="row mt-3">

<div class="col-md-9">
    <div class="card">
        <div class="card-header d-flex flex-row justify-content-between">        
            <h2 class="card-title mb-0">Expenses</h2>
            <div class="d-flex flex-row gap-3 align-items-center">
                <div class="d-flex flex-row" style="gap: 10px;">
                    <button class="btn btn-sm btn-primary" [routerLink]="['/lo', company_uuid, 'account','form','new']" *ngIf="permission['expenses-admin']">Add</button>
                    <button class="btn btn-sm btn-primary" (click)="copy()" [disabled]="is_loading">COPY</button>
                    <button class="btn btn-sm btn-primary" (click)="paste()" [disabled]="is_loading">PASTE</button>
                </div>
            </div>
        </div>
        <div class="card-body p-0">
            <div class="d-flex flex-row justify-content-between">
                <div class="d-flex flex-row align-items-center px-2" style="gap: 10px">
                    <span class="text-nowrap">Ledger Month/Year</span>
                    <input type="month" class="form-control form-control-sm" [(ngModel)]="filterMonth" (change)="monthChange()" *ngIf="is_mario"/>
                    <select class="form-control form-control-sm" [(ngModel)]="filterMonth" (change)="monthChange()" *ngIf="!is_mario">
                        <option *ngFor="let month of months" [value]="month.value">{{month.label}}</option>
                    </select>
                </div>
                <ul class="nav nav-tabs">
                    <li class="nav-item">
                        <a class="nav-link" [ngClass]="{'active': type == 'all'}" (click)="switchLedger('all')">Ledger</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" [ngClass]="{'active': type == 'debit'}" (click)="switchLedger('debit')">Debit进</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" [ngClass]="{'active': type == 'credit'}" (click)="switchLedger('credit')">Credit出</a>
                    </li>
                </ul>
            </div>
            
            <app-table #table ></app-table>
                    <!-- <div class="d-flex flex-row justify-content-between"><span>Total Unclaim: {{configuration.currency == "none" ? "": configuration.currency}}</span><span>{{unclaim | number: '1.2-2' }}</span></div> -->

        </div>
    </div>
</div>


<div class="col-12 col-md-3" *ngIf="permission['expenses-admin']">
    <table class="table table-striped">
        <thead>
            <tr>
                <th colspan="2">Unclaim Summary</th>
            </tr>
            <tr>
                <th>Admin</th>
                <th>Total</th>    
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let unclaim of unclaims">
                <td>{{unclaim.create_by}}</td>
                <td class="text-end"><div class="d-flex flex-row justify-content-between"><span>{{configuration.currency == "none" ? "": configuration.currency}}</span><span>{{unclaim.total | number: '1.2-2' }}</span></div></td>
            </tr>
            <tr *ngIf="unclaims.length == 0"><th colspan="2">No Data Available</th></tr>
        </tbody>
    </table>
</div>
</div>